import React from "react";
import { useNavigate } from "react-router-dom";

import styled from "styled-components";

const BackButtonWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 80px;
  border: 1px solid rgba(230, 233, 239, 1);
  padding: 4px;
  cursor: pointer;
  flex-shrink: 0;
  box-sizing: border-box;
`;

const HeaderBackButton = styled.button`
    display: inline-flex;
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8ebf1;
    border-radius: 50%;
    background: #ffffff;
    cursor: pointer;
`;

const BackButton =({pathName, variant, onClick}) =>{

    const navigate = useNavigate();
    const handleBack = () => {
        if (onClick) {
            onClick();
            return;
        }
        if (pathName) {
            navigate({ pathname: pathName });
        } else {
            navigate(-1);
        }
    }

    if (variant === "header") {
        return (
            <HeaderBackButton
                type="button"
                aria-label="Go back"
                title="Go back"
                onClick={handleBack}
            >
                <img
                    src="/logos/back_logo.svg"
                    alt=""
                    width="8"
                    height="15"
                    aria-hidden="true"
                />
            </HeaderBackButton>
        )
    }

    return(
        <React.Fragment>
            <BackButtonWrapper className="mr-4" onClick={handleBack}>
                <img src="/logos/Vector.svg" />
            </BackButtonWrapper>
        </React.Fragment>
    )
}

export default BackButton;
